/* global axios */

import ApiClient from './ApiClient';

class PostSaleCaseNotesAPI extends ApiClient {
  constructor() {
    super('post_sale_cases', { accountScoped: true });
  }

  notesUrl(postSaleCaseId) {
    return `${this.url}/${postSaleCaseId}/notes`;
  }

  list(postSaleCaseId) {
    return axios.get(this.notesUrl(postSaleCaseId));
  }

  create(postSaleCaseId, payload = {}) {
    return axios.post(this.notesUrl(postSaleCaseId), payload);
  }

  update(postSaleCaseId, noteId, payload = {}) {
    return axios.patch(`${this.notesUrl(postSaleCaseId)}/${noteId}`, payload);
  }

  destroy(postSaleCaseId, noteId, payload = {}) {
    return axios.delete(`${this.notesUrl(postSaleCaseId)}/${noteId}`, {
      data: payload,
    });
  }
}

export default new PostSaleCaseNotesAPI();
